// config.js
export const BASE_URL = "https://www.education.artindiamag.com";
// export const BASE_URL = "http://localhost:8000";
export const IMAGE_URL = `${BASE_URL}/api/secure-profile-image`;
export const VIDEO_URL = `${BASE_URL}/api/video-stream`;